<template>
  <router-view/>
  <notifications position="top center" width="100%" class="notification-style" :max="1" :duration="3000"/>
  <FullscreenMessage />

</template>
<script>
import FullscreenMessage from '@/components/common/FullscreenMessage.vue'
export default {
  components: {
    FullscreenMessage
  }
} 
</script>

<style>
.vue-notification {
  font-size: 16px;
}
.notification-content {
  font-size: 18px;
}
#app {
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
